/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAgentFactory = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path d="M15 19h-2v-2h2v2zm4 0h-2v-2h2v2z" fill="currentcolor" />
      <path
        d="M17 14h3a2 2 0 0 1 2 2v1h1v2h-1v2a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2H9v-2h1v-1a2 2 0 0 1 2-2h3v-2h2v2zm-5 7h3v-1h2v1h3v-5h-8v5z"
        fill="currentcolor"
      />
      <path
        d="m8 7.483 7-3v3l7-3V12h-2V7.516l-7 3v-3l-7 3V4H4v16h4v2H2V2h6v5.483z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAgentFactory as AgentFactory };
